import { convertToNumber } from './number-utils';

export interface ElementPosition {
  id: string | null;
  top: number | null;
  left: number | null;
  width: number | null;
  height: number | null;
}

export function isDataURL(value: string) {
  return !!value.match(
    /^\s*data:(\w+\/[-.\w]+(?:\+[-.\w]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i
  );
}

export function getImageProps(image: SVGImageElement) {
  const url = image.getAttribute('xlink:href');
  const width = convertToNumber(image.getAttribute('width'));
  const height = convertToNumber(image.getAttribute('height'));

  return {
    url,
    width,
    height,
  };
}

export function getElementPositionProps(element: Element): ElementPosition {
  const id = element.getAttribute('id') ?? null;
  const width = convertToNumber(element.getAttribute('width')) || null;
  const height = convertToNumber(element.getAttribute('height')) || null;
  const top = convertToNumber(element.getAttribute('y')) || (width ? 0 : null);
  const left = convertToNumber(element.getAttribute('x')) || (width ? 0 : null);

  return {
    id,
    top,
    left,
    height,
    width,
  };
}

export function getClipPath(element: Element): Element | null {
  const clipPathAttribute = element.getAttribute('clip-path');

  if (!clipPathAttribute) {
    return null;
  }

  const clipPathId = clipPathAttribute
    .replace('url(', '')
    .replace(')', '')
    .replace(/"/g, '')
    .trim();

  return document.querySelector(clipPathId);
}

export function getBoundingClientRect(element: Element | null): DOMRect | null {
  if (!element) return null;

  const clipPath = getClipPath(element);

  if (!clipPath) return element.getBoundingClientRect();

  return (clipPath.firstChild as Element).getBoundingClientRect();
}
